import React, {useEffect, useState} from "react";
import {
  apiAdminAccountFeaturesUpdate,
  apiAdminMerchantFeaturesList,
  apiAdminMerchantFeaturesUpdate
} from "../../../../../../api/admin/features";
import Loading from "../../../../../dumb/Loading";
import {AdminSwitch} from "../../../../../dumb/FormInputs";

const FeatureItem = ({data, update}) => {
  const {id, ...featureData} = data;
  const [loading, setLoading] = useState(false);
  return (
    <div className="rlv">
      <div
        className={
          `w h abs st sl o0 bgF z-1 (o50|z10).loading`
          + (loading ? ' loading' : '')
        }
      />
      <div
        className={
          `abs st50% sl50% x-50%Y-50% o0 z-1 (o100|z15).loading (c0)>.CircularProgress`
          + (loading ? ' loading' : '')
        }
      >
        <Loading />
      </div>
      <div
        className="h45 ph15 layoutRow jcSB aiC f16 fw3 tc ttU c3E4044 bgFAFAFA b1 bs bcDCDCDC"
      >
        <h3 className="f16">
          {id}
        </h3>
        <AdminSwitch
          name="full_refund"
          value={data.enabled}
          onChange={() => {
            setLoading(true);
            apiAdminMerchantFeaturesUpdate( {
              ...featureData,
              feature_id: data.id,
              enabled: !data.enabled
            })
              .then(update)
              .finally(() => setLoading(false))
          }}
          disabled={loading}
          disableLabel
        />
      </div>
      <div className="ph15 c3E4044 bgFFFF b1 bt0 bs bcDCDCDC">
        <div className="pv8">
          <b>Description: </b><span>{data['description']}</span>
        </div>
      </div>
    </div>
  )
}

export default () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    const getList = (obj = {}) => (obj.list || []);
    setData({featuresList: await apiAdminMerchantFeaturesList().then(getList)});
  }

  useEffect(async () => {
    fetchData().finally(() => setLoading(false));
  }, []);

  if (loading) return <span />;

  const {
    featuresList = []
  } = data;

  return (
    <>
      {featuresList.map((data) => {
        return (
          <div key={data.id} className="mv13">
            <FeatureItem
              id={data.id}
              data={data}
              update={fetchData}
            />
          </div>
        )
      })}
    </>
  );
}
